import { HOME_SHOW_MORE_POSTS, HOME_SUGGEST_ARTICLE } from 'mk/autogenerated/translations/Home.c882267d0779a13b02b40522334df58c'
import { isAuthenticated } from 'mk/bazaar/common/userUtils';
import Bazaar from 'mk2/apps/home/components/Bazaar';
import ForumPosts from 'mk2/apps/home/components/ForumPosts';
import Post, { PostPlaceholder } from 'mk2/apps/home/components/Post';
import SubscribedPhotoblogs from 'mk2/apps/home/components/SubscribedPhotoblogs';
import { Props } from 'mk2/apps/home/containers/Home/HomePage';
import Btn, { BtnSidePadding, BtnType } from 'mk2/components/Btn';
import Panel from 'mk2/components/Panel';
import TrackClick from 'mk2/components/TrackClick';
import LoadingSwitch from 'mk2/containers/LoadingSwitch/LoadingSwitch';
import { isSuccess, LoadingState } from 'mk2/reducers/loadingState';
import * as React from 'react';
import styles from './Home.mscss';

class Home extends React.Component<Props> {

    public shouldComponentUpdate(n: Props) {
        const p = this.props;

        return p.homePosts !== n.homePosts
            && p.loadingState !== n.loadingState;
    }

    public render() {
        const { loadingState, homePosts, bazaarCounts, history } = this.props;

        return (
            <div className={styles.Home}>
                <Bazaar className={styles.Home__bazaar} history={history} {...bazaarCounts} />

                <LoadingSwitch
                    loadingState={loadingState}
                    onLoad={this.load}
                    onRenderSuccess={this.renderSuccess}
                    onRenderInit={this.renderInit}
                    hasData={homePosts && homePosts.length > 0}
                />
            </div>
        );
    }

    private renderInit = () => {
        const {mobile} = this.props;
        return (
            <Panel>
                {Array.from(Array(mobile ? 6 : 30).keys()).map((index) => (
                    <PostPlaceholder key={index} mobile={mobile} className={styles.Home__post} />
                ))}
            </Panel>
        );
    };

    private renderSuccess = () => {
        const { homePosts, nextPage, pageLoadingState, mobile, lastVisitCountFriends, requestUser, forumPostsVariant, forumPosts } = this.props;
        const showForumPosts = isSuccess(forumPostsVariant.loadingState) && forumPostsVariant.variant === 'yes';

        return (
            <>
                {isAuthenticated(requestUser) &&
                    <SubscribedPhotoblogs className={styles.Home__subscribedPhotoblog} lastVisitCountFriends={lastVisitCountFriends}/>
                }
                {showForumPosts && (
                    <ForumPosts posts={forumPosts} className={styles.Home__forumPosts} />
                )}
                <Panel className={styles.Home__posts}>
                    {homePosts.map((post, index) => (
                        <div key={post.id}>
                            <TrackClick
                                name="homepage_feed_click"
                                props={{
                                    url: post.url,
                                    position: index + 1,
                                }}
                            >
                                <Post mobile={mobile} className={styles.Home__post} post={post} />
                            </TrackClick>
                        </div>
                    ))}
                    {pageLoadingState === LoadingState.LOADING && (
                        <PostPlaceholder mobile={mobile} className={styles.Home__post} />
                    )}
                    <div className={styles.Home__pager}>
                        {pageLoadingState !== LoadingState.LOADING && nextPage ? (
                            <TrackClick
                                name="homepage_feed_click"
                                props={{
                                    url: 'load_more',
                                    position: 0,
                                    page: nextPage,
                                }}
                            >
                                <Btn type={BtnType.BlueOutline} label={HOME_SHOW_MORE_POSTS} onClick={this.loadPage} />
                            </TrackClick>
                        ) : (// Needed for spacing in the flex
                            <div />
                        )}
                        <Btn
                            type={BtnType.Link}
                            icon="fa-link"
                            label={HOME_SUGGEST_ARTICLE}
                            onClick={this.onSuggestArticle}
                            sidePadding={BtnSidePadding.None}
                        />
                    </div>
                </Panel>
            </>
        );
    };

    private load = () => {
        const { forumPostsVariant, onLoadAB, mobile } = this.props;
        if (mobile && !isSuccess(forumPostsVariant.loadingState)) {
            onLoadAB();
        }

        this.props.onLoad();
    };

    private loadPage = () => {
        if (this.props.nextPage && this.props.pageLoadingState !== LoadingState.LOADING) {
            this.props.onLoadPage(this.props.nextPage);
        }
    };

    private onSuggestArticle = () => {
        this.props.onSuggestArticle();
    };

}

export default Home;
